/**
 * Fix: price-range lazy init via IntersectionObserver fires only when the element
 * enters the viewport. Inside a closed drawer (translated off-screen via CSS transform)
 * the element is never "in viewport", so init() and the slider event listeners are
 * never set up. Re-trigger init() the first time the facet drawer opens.
 */
document.addEventListener('DOMContentLoaded', function () {
  var facetDrawer = document.getElementById('facet-filters');
  if (!facetDrawer) return;

  facetDrawer.addEventListener('on:facet-filters:after-open', function () {
    var priceRange = facetDrawer.querySelector('price-range');
    if (priceRange && typeof priceRange.init === 'function' && !priceRange.minNumberInput) {
      priceRange.init();
    }
  }, { once: false });
});

/**
 * Judge.me Bewertungs-Modal aufwerten:
 *  - Überschrift ("Wie würden Sie ...") in Archivo Black
 *  - Produkttitel in Tuning-Edition-Badge + Titel + Subheading aufsplitten
 * Vollständig defensiv: fehlt ein Element oder passt der Titel nicht ins Schema
 * ("... - Subheading | HEIMKINO.de Tuning Edition"), bleibt alles unverändert.
 */
(function () {
  function enhanceReviewModal() {
    var modal = document.querySelector('.jdgm-write-review-modal');
    if (!modal) return;

    // Überschrift in Archivo Black
    var header = modal.querySelector('.jdgm-write-review-modal__page-header');
    if (header) {
      var h = header.querySelector('h1, h2, h3, h4') || header.firstElementChild;
      if (h) h.style.setProperty('font-family', "'Archivo Black', archivo, sans-serif", 'important');
    }

    // Produkttitel aufsplitten (nur bei Tuning-Edition-Produkten)
    var titleEl = modal.querySelector('.jdgm-write-review-modal__product-title');
    if (!titleEl) return;
    var full = titleEl.dataset.feFull || (titleEl.textContent || '').trim();
    if (!full) return;
    titleEl.dataset.feFull = full;
    if (full.toLowerCase().indexOf('tuning edition') === -1) return;

    var parent = titleEl.parentNode;
    if (!parent) return;
    // Idempotenz: schon in Wrapper verpackt?
    if (titleEl.closest('.fe-te-titleblock')) return;

    // "Titel - Subheading | HEIMKINO.de Tuning Edition"
    var mainPart = full;
    var pipeIdx = full.lastIndexOf('|');
    if (pipeIdx !== -1) mainPart = full.slice(0, pipeIdx).trim();
    var title = mainPart, subheading = '';
    var dashIdx = mainPart.indexOf(' - ');
    if (dashIdx !== -1) {
      title = mainPart.slice(0, dashIdx).trim();
      subheading = mainPart.slice(dashIdx + 3).trim();
    }

    // Badge + Titel + Subheading als eine kompakte Gruppe (ein Flex-Item)
    var block = document.createElement('div');
    block.className = 'fe-te-titleblock';
    parent.insertBefore(block, titleEl);

    var badge = document.createElement('div');
    badge.className = 'fe-te-badge';
    badge.textContent = 'HEIMKINO.de Tuning Edition';
    block.appendChild(badge);

    titleEl.textContent = title;
    block.appendChild(titleEl);

    if (subheading) {
      var sub = document.createElement('div');
      sub.className = 'fe-te-subheading';
      sub.textContent = subheading;
      block.appendChild(sub);
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.jdgm-write-rev-link')) {
      setTimeout(enhanceReviewModal, 50);
      setTimeout(enhanceReviewModal, 300);
    }
  });
})();

/**
 * Judge.me "Bewertungen"-Badge oben (Sterne neben dem Titel): sauber an den ANFANG
 * der Review-Section scrollen. Judge.me scrollt oft, bevor die Reviews fertig
 * gerendert sind → man landet zu weit unten. Nach kurzer Verzögerung korrigieren.
 */
document.addEventListener('click', function (e) {
  var badge = e.target.closest && e.target.closest('.jdgm-prev-badge');
  if (!badge) return;
  var target = document.querySelector('.jdgm-rev-widg__header')
            || document.querySelector('.jdgm-rev-widg');
  if (!target) return; // kein Widget auf der Seite → Judge.me-Standard nicht anfassen
  // Judge.me-eigenen Scroll unterbinden und selbst sauber zum Anfang scrollen
  e.preventDefault();
  e.stopPropagation();
  var scrollToTop = function () {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  scrollToTop();
  // Nachkorrektur: Layout kann sich durch nachladende Inhalte noch verschieben
  setTimeout(scrollToTop, 600);
}, true);

/**
 * Simple Bundles: PDP-Preis bei Options-Auswahl aktualisieren.
 * Die App rechnet den Aufpreis (data-price-diff) korrekt im Warenkorb,
 * aktualisiert aber die Preisanzeige unseres Themes nicht.
 * Basispreis = angezeigter Preis minus Aufpreise der initial gewählten Optionen.
 */
document.addEventListener('DOMContentLoaded', function () {
  var optionsWrap = document.querySelector('[id^="simple-bundles-io-options"]');
  if (!optionsWrap) return;
  var selects = optionsWrap.querySelectorAll('select');
  if (!selects.length) return;
  var priceEl = document.querySelector('.cc-main-product .product-info__price .price__current')
             || document.querySelector('.cc-main-product .price__current');
  if (!priceEl) return;

  // Alle Preis-Anzeigen: Hauptpreis, Sticky-ATC-Leiste, Consulting-Sticky-Leiste.
  // Bei jedem Update frisch suchen, da manche Leisten erst später gerendert werden.
  function getPriceTargets() {
    var list = [priceEl];
    document.querySelectorAll('sticky-atc-panel .price__current, .consulting__price').forEach(function (el) {
      if (list.indexOf(el) === -1) list.push(el);
    });
    return list;
  }

  function parsePrice(text) {
    // "5.348,00€" → 5348.00
    var m = (text || '').replace(/[^\d.,]/g, '');
    if (!m) return NaN;
    return parseFloat(m.replace(/\./g, '').replace(',', '.'));
  }
  function formatPrice(num) {
    return num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
  }
  function sumDiffs() {
    var sum = 0;
    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var d = parseFloat(opt.getAttribute('data-price-diff'));
      if (!isNaN(d)) sum += d;
    });
    return sum;
  }

  var displayed = parsePrice(priceEl.textContent);
  if (isNaN(displayed)) return;
  var basePrice = displayed - sumDiffs();

  function updatePrice() {
    var text = formatPrice(basePrice + sumDiffs());
    getPriceTargets().forEach(function (el) { el.textContent = text; });
  }
  selects.forEach(function (sel) {
    sel.addEventListener('change', updatePrice);
  });
  // Sticky-Leisten erscheinen erst beim Scrollen — dann ggf. nachziehen
  window.addEventListener('scroll', function () {
    if (sumDiffs() !== 0) updatePrice();
  }, { passive: true });
});

/**
 * Bundle-Upsell-Karten: USPs aus dem Metafeld custom.bundle_usps anzeigen
 * (mehrzeiliger Text, eine Zeile = ein USP). Metafelder stecken nicht im
 * Produkt-JSON, daher wird die Mini-Section "bundle-usps-json" per
 * Section-Rendering-API im Kontext des Bundle-Produkts geladen.
 */
document.addEventListener('DOMContentLoaded', function () {
  function initCards() {
    document.querySelectorAll('.pdp-bundle-upsell__item').forEach(function (item) {
      // Titel wie auf der PDP splitten: Teil nach " - " wird kleine Subline
      var titleEl = item.querySelector('a.pdp-bundle-upsell__title');
      if (titleEl && item.dataset.feTitleSplit !== '1') {
        item.dataset.feTitleSplit = '1';
        var full = (titleEl.textContent || '').trim();
        var sep = full.indexOf(' – ') !== -1 ? ' – ' : (full.indexOf(' - ') !== -1 ? ' - ' : '');
        if (sep) {
          var idx = full.indexOf(sep);
          titleEl.textContent = full.slice(0, idx).trim();
          var sub = document.createElement('div');
          sub.className = 'fe-bundle-subline';
          sub.textContent = full.slice(idx + sep.length).trim();
          titleEl.parentNode.insertBefore(sub, titleEl.nextSibling);
        }
      }
      if (item.dataset.feUsps === '1') return;
      var link = item.querySelector('a.pdp-bundle-upsell__title, a.pdp-bundle-upsell__image');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      item.dataset.feUsps = '1';
      fetch('/products/' + m[1] + '?section_id=bundle-usps-json')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var out = tmp.querySelector('.fe-bundle-usps');
          if (!out || !out.children.length) return;
          var details = item.querySelector('.pdp-bundle-upsell__details');
          var price = item.querySelector('.pdp-bundle-upsell__price');
          // Text ÜBER den Preis setzen
          if (price && price.parentNode) price.parentNode.insertBefore(out, price);
          else if (details) details.appendChild(out);
        })
        .catch(function () {});
    });
  }
  initCards();
  // App hydratisiert das Carousel ggf. verzögert
  setTimeout(initCards, 800);
});

/**
 * Bundle-Optionen → Galerie-Bild wechseln.
 * Zuordnung über Alt-Texte der Galerie-Bilder per Wort-Scoring gegen ALLE
 * aktuellen Auswahlen (Beamer + Leinwand + ...). Es gewinnt das Bild, dessen
 * Alt-Wörter (ab 3 Zeichen) am meisten Treffer haben — dadurch schlägt ein
 * passendes Kombi-Bild ("Epson ... Motorleinwand") automatisch die Bilder,
 * die nur eine der beiden Optionen abdecken.
 * Kein Treffer (Score 0) = Galerie bleibt unverändert.
 */
document.addEventListener('change', function (e) {
  var sel = e.target;
  if (!sel || sel.tagName !== 'SELECT') return;
  var wrap = sel.closest('[id^="simple-bundles-io-options"]');
  if (!wrap) return;

  var SPLIT = /[^a-z0-9äöüß"]+/;

  // ALLE aktuellen Auswahlen zusammenfassen (Beamer + Leinwand + ...),
  // damit auch Kombi-Bilder ("Epson + Motorleinwand") korrekt gewinnen.
  // Als Wort-Menge, damit exakt verglichen wird (kein "max" in "maximal").
  var words = {};
  var hasWords = false;
  wrap.querySelectorAll('select').forEach(function (s) {
    if (!s.value) return;
    s.value.toLowerCase().split(SPLIT).forEach(function (token) {
      if (token.length >= 3) { words[token] = true; hasWords = true; }
    });
  });
  if (!hasWords) return;

  var thumbs = document.querySelectorAll('.media-gallery__thumbs .media-thumbs__btn');
  var best = null;
  var bestScore = 0;
  thumbs.forEach(function (btn) {
    var img = btn.querySelector('img');
    var alt = img ? (img.getAttribute('alt') || '').trim().toLowerCase() : '';
    if (alt.length < 3) return;
    // Wort-Scoring: wie viele Alt-Wörter (ab 3 Zeichen) stehen in der Auswahl?
    // Jedes Wort zählt nur einmal, damit lange Alt-Texte nicht künstlich punkten.
    var score = 0;
    var seen = {};
    alt.split(SPLIT).forEach(function (token) {
      if (token.length >= 3 && !seen[token] && words[token]) {
        seen[token] = true;
        score += 1;
      }
    });
    if (score > bestScore) {
      best = btn;
      bestScore = score;
    }
  });
  if (best) best.click();
});

